var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDuration1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-3,.cls-4{stroke:#af9b5b;}.cls-2,.cls-4{fill:#af9b5b;}.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-4{stroke-miterlimit:10;}.cls-5{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "duree1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,31A13.47,13.47,0,1,1,27.53,17.51,13.47,13.47,0,0,1,41,31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.16,20.43a13.18,13.18,0,0,0-1.71,1.63l-1-1,1.67-1.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.48,
    y: 18.65,
    width: 4.4,
    height: 1.78,
    transform: "translate(-8.93 17.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.6,21.05l-1,1a13.9,13.9,0,0,0-1.72-1.63l1-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.46,
    y: 17.34,
    width: 1.78,
    height: 4.4,
    transform: "translate(-2.58 32.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.86,31a2.81,2.81,0,0,1,0,.29,9.89,9.89,0,0,1-.67,3.4c-.06.18-.14.35-.22.53A10,10,0,0,1,35,38.08c-.13.14-.26.27-.4.4a10,10,0,0,1-2.89,1.93,3.38,3.38,0,0,1-.52.22,9.9,9.9,0,0,1-3.41.67,1.27,1.27,0,0,1-.28,0,1.32,1.32,0,0,1-.28,0,9.9,9.9,0,0,1-3.41-.67l-.53-.22a10,10,0,0,1-2.88-1.93c-.14-.13-.27-.26-.4-.4A10,10,0,0,1,18.1,35.2a4,4,0,0,1-.22-.53,9.89,9.89,0,0,1-.67-3.4,1.42,1.42,0,0,1,0-.29,1.37,1.37,0,0,1,0-.28,10.13,10.13,0,0,1,.66-3.41c.07-.17.14-.35.22-.52A10.33,10.33,0,0,1,20,23.88c.13-.14.26-.27.4-.4a10,10,0,0,1,2.88-1.93l.53-.22a9.9,9.9,0,0,1,3.41-.67h.56a9.9,9.9,0,0,1,3.41.67,4.77,4.77,0,0,1,.52.22,10,10,0,0,1,2.89,1.93c.14.13.27.26.4.4A10.33,10.33,0,0,1,37,26.77l.22.52a10.13,10.13,0,0,1,.66,3.41,2.72,2.72,0,0,1,0,.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.33,16v1.72a14.41,14.41,0,0,1,2.2-.18,14.64,14.64,0,0,1,2.21.18V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.35,16H24.71a3,3,0,1,1,0-6h5.64a3,3,0,1,1,0,6m-5.64-4.39a1.42,1.42,0,1,0,0,2.83h5.64a1.42,1.42,0,1,0,0-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.62,33.54a6.61,6.61,0,1,1-3.53-8.65,6.61,6.61,0,0,1,3.53,8.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.68,27l1.29.55-.21.49-1.29-.54a2,2,0,0,1,.09-.26c0-.08.07-.16.12-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.3,34l1.29.54a1.84,1.84,0,0,1-.09.25c0,.08-.07.17-.12.25l-1.28-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.22,30.68v.53h-1.4v-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.25,30.76a4.69,4.69,0,0,1,0,.53h-1.4v-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.73,33.88l.2.5-1.29.52c-.07-.16-.14-.33-.2-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.42,27.06c.08.16.14.32.21.49l-1.3.53-.2-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.44,36.64l.37.39-1,1c-.13-.13-.25-.25-.37-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.25,24c.13.12.25.25.37.38l-1,1-.38-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.07,38.55l.49.2L24,40a1.84,1.84,0,0,1-.25-.09l-.24-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.3,22c.08,0,.16.07.24.12L31,23.41l-.49-.2.54-1.29.25.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.76,39.3v1.4h-.53V39.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.85,21.26v1.4h-.53v-1.4a4.86,4.86,0,0,1,.54,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.92,38.58l.53,1.29-.49.2-.53-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.1,21.89l.53,1.29-.49.2-.53-1.29a5,5,0,0,1,.49-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.57,36.7l1,1-.38.37-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.88,23.89l1,1-.38.38-1-1c.12-.13.25-.25.38-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.09,29.41l3.78-2.5L29.2,30.57a1.65,1.65,0,0,1-.46,1.59,1.64,1.64,0,1,1-.65-2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.18,31.62A.86.86,0,0,0,27,30.38a.86.86,0,1,0,1.18,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.09,24.89a6.66,6.66,0,0,1,2,1.35,30.16,30.16,0,0,0,2.5-2.76,10,10,0,0,0-2.89-1.93,4.77,4.77,0,0,0-.52-.22,9.9,9.9,0,0,0-3.41-.67h-.56l.1,3.72A6.63,6.63,0,0,1,30.09,24.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuration1);
export default __webpack_public_path__ + "static/media/icon_duration_1.3730bda14fc914d3034b3086c88c9ab8.svg";
export { ForwardRef as ReactComponent };